<template>
  <div>
    <vxe-modal
      v-model="classDialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>选择课程</span>
      </template>
      <template #default>
        <div class="btn-content">
          <el-button
            class="custom-button w-btn"
            size="small"
            type="primary"
            @click="handleSubmit"
            >保存
          </el-button>
          <el-button size="small" type="default" @click="handleCancel">
            关闭
          </el-button>
        </div>
        <el-row :gutter="24" style="height: 45px">
          <el-col :span="18">
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              label-position="right"
              size="small"
              class="w-form"
            >
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="课程标题">
                    <el-input
                      v-model="PageQuery.queryModel.title"
                      placeholder="课程标题"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="课程分类">
                    <el-select
                      v-model="PageQuery.queryModel.courseCategoryIds"
                      clearable
                      multiple
                      collapse-tags
                      collapse-tags-tooltip
                    >
                      <el-option
                        v-for="(item, index) in CategoryList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
          <el-col :span="6" style="text-align: right">
            <el-form-item>
              <el-button
                class="hbn-button-serach"
                type="primary"
                size="small"
                @click="getClassList"
                >查找</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <vxe-table
          :data="DataList"
          round
          border
          height="420"
          class="mytable-scrollbar"
          style="width: 100%"
          :highlight-current-row="true"
          ref="multipleTable"
          highlight-hover-row
          highlight-hover-column
          highlight-current-column
          show-overflow="tooltip"
          empty-text="没有更多数据了！"
          resizable
          stripe
          @checkbox-change="handleSelectionChange"
          @checkbox-all="handleSelectionChange"
        >
          <vxe-table-column
            fixed="left"
            type="checkbox"
            width="40"
          ></vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="课程标题"
            field="title"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="讲师"
            field="teacherName"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="课程分类"
            field="courseCategoryName"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="播放量"
            field="watchNumber"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="点赞量"
            field="tasgNumber"
            align="center"
          ></vxe-table-column>
          <vxe-table-column
            show-overflow-tooltip
            title="创建时间"
            field="creationTime"
            align="center"
            :formatter="formatterData"
          >
          </vxe-table-column>
        </vxe-table>
        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
import { getClassList, getCategoryList } from "@api/Basic";
import { dateFormat } from "@/util/utils.js";
export default {
  props: {
    classDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CategoryList: [],
      DataList: [],
      PageQuery: {
        queryModel: {
          title: "",
          courseCategoryIds: [],
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
    };
  },
  created() {
    this.getClassCategoryList();
    this.getClassList();
  },
  methods: {
    // 获取课程列表
    getClassList() {
      getClassList(this.PageQuery).then((res) => {
        this.DataList = res.entities;
        this.total = res.totalCount;
      });
    },
    // 获取课程分类
    getClassCategoryList() {
      getCategoryList().then((res) => {
        res.forEach((item) => {
          this.CategoryList.push(item);
          item.childs.forEach((row) => {
            this.CategoryList.push(row);
          });
        });
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      return dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.getClassList();
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val.records;
    },
    handleSubmit() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择课程");
        return;
      }
      this.$emit("handle-confirm", this.multipleSelection);
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-content {
  text-align: right;
  margin-bottom: 16px;
  .custom-button {
    background: #f7971e;
    border: 0;
  }
}
.w-form {
  :deep(.el-form-item) {
    margin-bottom: 0;
  }
}
.hbn-button-serach {
  background: #0747a6;
  border: 0;
}
</style>